import React from "react";
import MyComponent from "./sub-components/assets";

export default class ElectrodeElectrifyReactComponent19 extends React.Component {
  render() {
    return (<MyComponent />);
  }
}

ElectrodeElectrifyReactComponent19.displayName = "ElectrodeElectrifyReactComponent19";

ElectrodeElectrifyReactComponent19.propTypes = {};

ElectrodeElectrifyReactComponent19.defaultProps = {};



// WEBPACK FOOTER //
// ./src/components/electrode-electrify-react-component.jsx